export default {
      id: "login-hh-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "sprite-46b249.svg#login-hh-usage",
      toString: function () {
        return this.url;
      }
    }